import React, { useState } from "react";
import { Container } from "react-bootstrap";

import "../../../css/Cards.scss";

function CardFlipper(props) {
  const [isFlipped, setFlipped] = useState(false);
  const toggleFlip = () => {
    setFlipped(!isFlipped);
  };
  return (
    <div className={isFlipped ? 'flip-card flipped' : 'flip-card'} onClick={toggleFlip}>
      <div className="boxes">
        <div className="box front">
          {props.front}
          <span className="flip-instructions" onClick={toggleFlip}>
            FLIP FOR QUESTIONS
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.167 20C7.78366 20 5.67533 19.25 3.84199 17.75C2.00866 16.25 0.850326 14.3333 0.366992 12H2.41699C2.88366 13.7667 3.83366 15.2083 5.26699 16.325C6.70033 17.4417 8.33366 18 10.167 18C11.6003 18 12.9337 17.646 14.167 16.938C15.4003 16.23 16.367 15.2507 17.067 14H14.167V12H20.167V18H18.167V16C17.217 17.2667 16.042 18.25 14.642 18.95C13.242 19.65 11.7503 20 10.167 20ZM0.166992 8V2H2.16699V4C3.11699 2.73333 4.29199 1.75 5.69199 1.05C7.09199 0.35 8.58366 0 10.167 0C12.5503 0 14.6587 0.75 16.492 2.25C18.3253 3.75 19.4837 5.66667 19.967 8H17.917C17.4503 6.23333 16.5003 4.79167 15.067 3.675C13.6337 2.55833 12.0003 2 10.167 2C8.73366 2 7.40033 2.35433 6.16699 3.063C4.93366 3.77167 3.96699 4.75067 3.26699 6H6.16699V8H0.166992Z" fill="#E05A44"/>
            </svg>
          </span>
        </div>
        <div className="box back">
          {props.back}
          <span className="flip-instructions">
            FLIP BACK
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.167 20C7.78366 20 5.67533 19.25 3.84199 17.75C2.00866 16.25 0.850326 14.3333 0.366992 12H2.41699C2.88366 13.7667 3.83366 15.2083 5.26699 16.325C6.70033 17.4417 8.33366 18 10.167 18C11.6003 18 12.9337 17.646 14.167 16.938C15.4003 16.23 16.367 15.2507 17.067 14H14.167V12H20.167V18H18.167V16C17.217 17.2667 16.042 18.25 14.642 18.95C13.242 19.65 11.7503 20 10.167 20ZM0.166992 8V2H2.16699V4C3.11699 2.73333 4.29199 1.75 5.69199 1.05C7.09199 0.35 8.58366 0 10.167 0C12.5503 0 14.6587 0.75 16.492 2.25C18.3253 3.75 19.4837 5.66667 19.967 8H17.917C17.4503 6.23333 16.5003 4.79167 15.067 3.675C13.6337 2.55833 12.0003 2 10.167 2C8.73366 2 7.40033 2.35433 6.16699 3.063C4.93366 3.77167 3.96699 4.75067 3.26699 6H6.16699V8H0.166992Z" fill="#ffffff"/>
            </svg>
          </span>
        </div>
      </div>
    </div>
  );
}

export default CardFlipper;
